module.exports = __webpack_public_path__ + "img/e8161ec52462a47d5c54b927ce4d6f6e.e8161ec5.png";